import React from 'react';
import { BarChart2, TrendingUp, PieChart, DollarSign } from 'lucide-react';

const metrics = [
  {
    id: 1,
    title: 'Bid Success Rate',
    value: '68%',
    change: '+4.2%',
    description: 'Average win rate across all proposals',
    icon: TrendingUp,
  },
  {
    id: 2,
    title: 'Total Contract Value',
    value: '$12.4M',
    change: '+15.3%',
    description: 'Combined value of active contracts',
    icon: DollarSign,
  },
  {
    id: 3,
    title: 'Market Share',
    value: '23%',
    change: '+2.1%',
    description: 'Share of awarded contracts in your sector',
    icon: PieChart,
  },
  {
    id: 4,
    title: 'Proposal Volume',
    value: '156',
    change: '+12.5%',
    description: 'Number of proposals submitted this year',
    icon: BarChart2,
  },
];

export function MarketplaceAnalytics() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {metrics.map((metric) => {
          const Icon = metric.icon;
          return (
            <div
              key={metric.id}
              className="relative overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:px-6"
            >
              <dt>
                <div className="absolute rounded-md bg-indigo-500 p-3">
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <p className="ml-16 truncate text-sm font-medium text-gray-500">{metric.title}</p>
              </dt>
              <dd className="ml-16">
                <p className="text-2xl font-semibold text-gray-900">{metric.value}</p>
                <p className="flex items-baseline text-sm font-semibold text-green-600">
                  {metric.change}
                  <span className="ml-2 text-gray-500">{metric.description}</span>
                </p>
              </dd>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-lg bg-white p-6 shadow">
          <h3 className="text-lg font-medium text-gray-900">Bid Performance Trends</h3>
          <div className="mt-6 h-64 rounded-lg bg-gray-50">
            {/* Placeholder for chart */}
            <div className="flex h-full items-center justify-center">
              <p className="text-sm text-gray-500">Performance chart visualization</p>
            </div>
          </div>
        </div>

        <div className="rounded-lg bg-white p-6 shadow">
          <h3 className="text-lg font-medium text-gray-900">Contract Distribution</h3>
          <div className="mt-6 h-64 rounded-lg bg-gray-50">
            {/* Placeholder for chart */}
            <div className="flex h-full items-center justify-center">
              <p className="text-sm text-gray-500">Distribution chart visualization</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}